import React, { useRef } from 'react'
import {
  TextField, Autocomplete, SxProps
} from '@mui/material'

export interface CustomAutocompleteInput {
  id: string
  value: string
}

interface PropsI {
  searchData: CustomAutocompleteInput[]
  onSearch: (filteredData: CustomAutocompleteInput[]) => void
  label: string
  sx?:SxProps
}

const CustomAutocomplete: ReactFC<PropsI> = ({
  onSearch,
  label,
  searchData,
  sx
}) => {
  const TextfieldEl = useRef<HTMLInputElement>(null)

  const [value, setValue] = React.useState('')
  const [textFieldValue, setTextFieldValue] = React.useState('')

  const handleChange = (newValue: string | null) => {
    if (!newValue && value) {
      setValue('')
      return onSearch(searchData)
    }
    if (!newValue) {
      return
    }
    setValue(newValue ?? '')
    const filteredData = searchData.filter((searchValue) =>
      searchValue.value.toLowerCase().includes(newValue.toLowerCase())
    )
    onSearch(filteredData)
  }

  return (
    <Autocomplete
      disablePortal
      id='combo-box-demo'
      sx={sx}
      options={searchData.map((searchData) => searchData.value)}
      onChange={(_, newValue: any) => {
        handleChange(newValue)
      }}
      value={value}
      isOptionEqualToValue={(option: any, value: any) => {
        return option.toLocaleLowerCase().includes(value.toLowerCase())
      }}
      inputValue={textFieldValue}
      onInputChange={(_, newTextFieldValue) => {
        setTextFieldValue(newTextFieldValue ?? '')
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          ref={TextfieldEl}
          label={label}
        />
      )}
    />
  )
}
export default CustomAutocomplete
